import React from 'react';

import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { ConditionType } from '@/models/ConditionModel.ts';
import { ChipSelector } from '@/uiKit/molecules/ControlledChipChoice.tsx';

export type DiabetesTypeSelectionFieldProps = {
  className?: string;
  allowedDiabetesTypes: ConditionType[];
};

export const DiabetesTypeSelectionField: React.FC<
  DiabetesTypeSelectionFieldProps
> = ({ className, allowedDiabetesTypes }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  const choices = allowedDiabetesTypes.map(type => ({
    displayName: t(`models.diabetesType.${type}`),
    value: type,
  }));

  return (
    <div className={cx(styles.container, className)}>
      <ChipSelector
        id="tls-diabetes-type-chips"
        label={t('diabetesForms.diabetesType')}
        fieldName="diabetesType"
        choices={choices}
      />
    </div>
  );
};

const makeStyles = () => ({
  container: css({}),
});
